import HttpClient from "../commons/HttpClient.js";

const appointmentsEndpoint = '/api/appointments';
const appointmentSearchEndpoint = appointmentsEndpoint + '/search';
const approveAppoinmentEndpoint = appointmentsEndpoint + "/approve";
const rescheduleAppoinmentEndpoint = appointmentsEndpoint + "/reschedule";
const rejectAppoinmentEndpoint = appointmentsEndpoint + "/reject";
const cancelAppoinmentEndpoint = appointmentsEndpoint + "/cancel";
const appointmentsStatsEndpoint = appointmentsEndpoint + '/stats';
const appointmentsMonthlyStatsEndpoint = appointmentsEndpoint + '/stats/monthly';
const appointmentsTodayEndpoint = '/api/appointments/today';
const appointmentsConfirmedTodayEndpoint = '/api/appointments/today/confirmed';
const appointmentsThisWeekEndpoint = '/api/appointments/current-week';
const appointmentsConfirmedThisWeekEndpoint = '/api/appointments/current-week/confirmed';
const appointmentsThisMonthEndpoint = '/api/appointments/current-month';
const appointmentsConfirmedThisMonthEndpoint = '/api/appointments/current-month/confirmed';

class AppointmentsClient extends HttpClient {

    constructor(host, apiKey) {
        super();
        this._apiKey = apiKey;
        this._host = host;
    }

    async create(data) {
        let url = this._host + appointmentsEndpoint;
        let headers = {
            'Content-Type': 'application/json'
        };
        if (localStorage.getItem('token')) {
            headers['X-AUTH-TOKEN'] = localStorage.getItem('token');
        }
        headers['X-API-KEY'] = this._apiKey;
        headers['X-DEVICE-ID'] = "aa=";
        return this.makeRequest(url, "POST", data, headers);
    }

    async search(data) {
        let url = this._host + appointmentSearchEndpoint;
        let headers = {
            'Content-Type': 'application/json'
        };
        if (localStorage.getItem('token')) {
            headers['X-AUTH-TOKEN'] = localStorage.getItem('token');
        }
        headers['X-API-KEY'] = this._apiKey;
        headers['X-DEVICE-ID'] = "aa=";
        return this.makeRequest(url, "POST", data, headers);
    }

    async fetchAllOfPage(query) {
        if (!('page' in query))
        query.page = 1;
    
        if (!('size' in query))
            query.size = 20;

        let url = this.getUrl(this._host + appointmentsEndpoint, query);
        let headers = {
            'Content-Type': 'application/json'
        };
        headers["X-API-KEY"] = this._apiKey;
        headers["X-DEVICE-ID"] = "aa=";
        if (localStorage.getItem('token')) {
            headers['X-AUTH-TOKEN'] = localStorage.getItem('token');
        }
        return this.makeRequest(
            url,
            "GET",
            {},
            headers
        );
    }

    async fetchAllOfToday(query) {
        if (!('page' in query))
        query.page = 1;
    
        if (!('size' in query))
            query.size = 20;

        let url = this.getUrl(this._host + appointmentsTodayEndpoint, query);
        let headers = {
            'Content-Type': 'application/json'
        };
        headers["X-API-KEY"] = this._apiKey;
        headers["X-DEVICE-ID"] = "aa=";
        if (localStorage.getItem('token')) {
            headers['X-AUTH-TOKEN'] = localStorage.getItem('token');
        }
        return this.makeRequest(
            url,
            "GET",
            {},
            headers
        );
    }

    async fetchAllConfirmedOfToday(query) {
        if (!('page' in query))
        query.page = 1;
    
        if (!('size' in query))
            query.size = 20;

        let url = this.getUrl(this._host + appointmentsConfirmedTodayEndpoint, query);
        let headers = {
            'Content-Type': 'application/json'
        };
        headers["X-API-KEY"] = this._apiKey;
        headers["X-DEVICE-ID"] = "aa=";
        if (localStorage.getItem('token')) {
            headers['X-AUTH-TOKEN'] = localStorage.getItem('token');
        }
        return this.makeRequest(
            url,
            "GET",
            {},
            headers
        );
    }

    async fetchAllOfThisWeek(query) {
        if (!('page' in query))
        query.page = 1;
    
        if (!('size' in query))
            query.size = 20;

        let url = this.getUrl(this._host + appointmentsThisWeekEndpoint, query);
        let headers = {
            'Content-Type': 'application/json'
        };
        headers["X-API-KEY"] = this._apiKey;
        headers["X-DEVICE-ID"] = "aa=";
        if (localStorage.getItem('token')) {
            headers['X-AUTH-TOKEN'] = localStorage.getItem('token');
        }
        return this.makeRequest(
            url,
            "GET",
            {},
            headers
        );
    }

    async fetchAllConfirmedOfThisWeek(query) {
        if (!('page' in query))
        query.page = 1;
    
        if (!('size' in query))
            query.size = 20;

        let url = this.getUrl(this._host + appointmentsConfirmedThisWeekEndpoint, query);
        let headers = {
            'Content-Type': 'application/json'
        };
        headers["X-API-KEY"] = this._apiKey;
        headers["X-DEVICE-ID"] = "aa=";
        if (localStorage.getItem('token')) {
            headers['X-AUTH-TOKEN'] = localStorage.getItem('token');
        }
        return this.makeRequest(
            url,
            "GET",
            {},
            headers
        );
    }

    async fetchAllOfThisMonth(query) {
        if (!('page' in query))
        query.page = 1;
    
        if (!('size' in query))
            query.size = 20;

        let url = this.getUrl(this._host + appointmentsThisMonthEndpoint, query);
        let headers = {
            'Content-Type': 'application/json'
        };
        headers["X-API-KEY"] = this._apiKey;
        headers["X-DEVICE-ID"] = "aa=";
        if (localStorage.getItem('token')) {
            headers['X-AUTH-TOKEN'] = localStorage.getItem('token');
        }
        return this.makeRequest(
            url,
            "GET",
            {},
            headers
        );
    }

    async fetchAllConfirmedOfThisMonth(query) {
        if (!('page' in query))
        query.page = 1;
    
        if (!('size' in query))
            query.size = 20;

        let url = this.getUrl(this._host + appointmentsConfirmedThisMonthEndpoint, query);
        let headers = {
            'Content-Type': 'application/json'
        };
        headers["X-API-KEY"] = this._apiKey;
        headers["X-DEVICE-ID"] = "aa=";
        if (localStorage.getItem('token')) {
            headers['X-AUTH-TOKEN'] = localStorage.getItem('token');
        }
        return this.makeRequest(
            url,
            "GET",
            {},
            headers
        );
    }

    async fetchStats() {
        let url = this._host + appointmentsStatsEndpoint;
        let headers = {
            'Content-Type': 'application/json'
        };
        headers["X-API-KEY"] = this._apiKey;
        headers["X-DEVICE-ID"] = "aa=";
        if (localStorage.getItem('token')) {
            headers['X-AUTH-TOKEN'] = localStorage.getItem('token');
        }
        return this.makeRequest(
            url,
            "GET",
            {},
            headers
        );
    }

    async fetchMonthlyCalendar(officialId, year, month) {
        let query = { officialId: officialId, year: year, month: month };
        let url = this.getUrl(this._host + appointmentsMonthlyStatsEndpoint, query);
        let headers = {
            'Content-Type': 'application/json'
        };
        headers["X-API-KEY"] = this._apiKey;
        headers["X-DEVICE-ID"] = "aa=";
        if (localStorage.getItem('token')) {
            headers['X-AUTH-TOKEN'] = localStorage.getItem('token');
        }
        return this.makeRequest(
            url,
            "GET",
            {},
            headers
        );
    }

    

    

    async approveAppoinment(data) {
        let url = this._host + approveAppoinmentEndpoint;
        let headers = {
            'Content-Type': 'application/json'
        };
        if (localStorage.getItem('token')) {
            headers['X-AUTH-TOKEN'] = localStorage.getItem('token');
        }
        headers['X-API-KEY'] = this._apiKey;
        headers['X-DEVICE-ID'] = "aa=";
        return this.makeRequest(url, "PATCH", data, headers);
    }

    async rescheduleAppoinment(data) {
        let url = this._host + rescheduleAppoinmentEndpoint;
        let headers = {
            'Content-Type': 'application/json'
        };
        if (localStorage.getItem('token')) {
            headers['X-AUTH-TOKEN'] = localStorage.getItem('token');
        }
        headers['X-API-KEY'] = this._apiKey;
        headers['X-DEVICE-ID'] = "aa=";
        return this.makeRequest(url, "PATCH", data, headers);
    }

    async rejectAppoinment(data) {
        let url = this._host + rejectAppoinmentEndpoint;
        let headers = {
            'Content-Type': 'application/json'
        };
        if (localStorage.getItem('token')) {
            headers['X-AUTH-TOKEN'] = localStorage.getItem('token');
        }
        headers['X-API-KEY'] = this._apiKey;
        headers['X-DEVICE-ID'] = "aa=";
        return this.makeRequest(url, "PATCH", data, headers);
    }

    async cancelAppoinment(data) {
        let url = this._host + cancelAppoinmentEndpoint;
        let headers = {
            'Content-Type': 'application/json'
        };
        if (localStorage.getItem('token')) {
            headers['X-AUTH-TOKEN'] = localStorage.getItem('token');
        }
        headers['X-API-KEY'] = this._apiKey;
        headers['X-DEVICE-ID'] = "aa=";
        return this.makeRequest(url, "PATCH", data, headers);
    }

}

export default AppointmentsClient;